import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Topbar from '../components/Topbar';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/Facturacion.css';

export default function Facturacion() {
  const history = useHistory();
  const { state } = useLocation();
  const actuaciones = state?.actuaciones || [];
  const [facturacion, setFacturacion] = useState([]);
  const expediente = state?.expediente;
  const pacienteNombre = state?.pacienteNombre;
  const pacienteNif = state?.pacienteNif;
  const [mostrarModal, setMostrarModal] = useState(false);
  const [selloSeleccionado, setSelloSeleccionado] = useState(null);

  useEffect(() => {
    const idsActuaciones = actuaciones.map(act => act.id); // Asegúrate de que cada actuación tiene un campo `id`
    if (idsActuaciones.length > 0) {
      axios.post('/api/facturacion', idsActuaciones, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => {
          console.log("Facturacion recibido:", res.data);
          setFacturacion(res.data);
        })
        .catch(err => {
          console.error("Error al generar Facturacion:", err);
        });
    }
  }, [actuaciones]);

  const calcularTotalFila = (cantidad, importe) => cantidad * importe;

  const totalGlobal = facturacion.reduce((acc, act) => {
    const cantidad = Number(act.cantidad || 1);
    const importe = Number(act.importe || 0);
    return acc + calcularTotalFila(cantidad, importe);
  }, 0);

  const generarPDF = (clinica) => {
    const items = facturacion.map(act => {
        console.log("🔎 Actuacion en generarPDF:", act);
        const cantidad = Number(act.cantidad || 1);
        const importe = Number(act.importe || 0);
        const total = cantidad * importe;

        return {
          id: act.id,
          fecha: act.dia ? new Date(act.dia).toLocaleDateString('es-ES') : new Date().toLocaleDateString('es-ES'),
          clave: act.clave,
          tratamiento: act.denominacion,
          pieza: act.pieza,
          cuadrante: act.cuadrante,
          cantidad: cantidad,
          precioUnitario: importe,
          total: total
        };
    });

    const datosFacturacion = {
      n_expediente: expediente,
      clinica: clinica,
      items: items,
      total: totalGlobal,
      fecha: new Date().toISOString().slice(0, 10),
      nombre_cliente: pacienteNombre|| "Paciente",
      nif: pacienteNif|| "Nif",
      nifEmisor: "B88084215",
      observaciones: "" // opcional
    };
    console.log("📤 Enviando datos a backend:", JSON.stringify(datosFacturacion, null, 2));
    axios.post('/api/facturacion/emitirPDF', datosFacturacion, {
        responseType: 'blob',
         headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
      })
      .catch((err) => {
        console.error("Error al generar PDF:", err);
      });
  };

  return (
    <>
      <Topbar />
      <div className="facturacion-page">
        <Breadcrumb />
        <h2>Facturacion</h2>
        <div className="acciones-superiores">
          <button className="btn-imprimir" onClick={() => setMostrarModal(true)}>
            Imprimir
          </button>
          <button
            className="volver-btn"
            onClick={() => history.push(`/pacientes/${expediente}/historial-clinico`)}
          >
            Volver al historial
          </button>
        </div>
        <table className="facturacion-table">
          <thead>
            <tr>
              <th>Clave</th>
              <th>Tratamiento</th>
              <th>Pieza</th>
              <th>Cuadrante</th>
              <th>Arcada</th>
              <th>Cantidad</th>
              <th>Importe</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {facturacion.map((act, index) => {
              const cantidad = Number(act.cantidad || 1);
              const importe = Number(act.importe || 0);
              const total = calcularTotalFila(cantidad, importe);

              return (
                <tr key={index}>
                  <td>{act.clave}</td>
                  <td>{act.denominacion}</td>
                  <td>{act.pieza}</td>
                  <td>{act.cuadrante}</td>
                  <td>{act.arcada}</td>
                  <td>{cantidad}</td>
                  <td>{importe.toFixed(2)} €</td>
                  <td>{total.toFixed(2)} €</td>
                </tr>
              );
            })}
            <tr className="fila-total">
              <td colSpan="7" style={{ textAlign: 'right' }}><strong>Total</strong></td>
              <td><strong>{totalGlobal.toFixed(2)} €</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      {mostrarModal && (
        <div className="modal-sello">
          <div className="modal-contenido">
            <h3>¿Con qué logo desea imprimir?</h3>
            <div className="opciones-sello">
              <label>
                <input
                  type="radio"
                  name="sello"
                  value="ELIPA"
                  checked={selloSeleccionado === "ELIPA"}
                  onChange={() => setSelloSeleccionado("ELIPA")}
                />
                ELIPA
              </label>
              <label>
                <input
                  type="radio"
                  name="sello"
                  value="VEN"
                  checked={selloSeleccionado === "VEN"}
                  onChange={() => setSelloSeleccionado("VEN")}
                />
                VEN
              </label>
            </div>
            <div className="acciones-modal">
              <button onClick={() => setMostrarModal(false)}>Cancelar</button>
              <button
                disabled={!selloSeleccionado}
                onClick={() => {
                  setMostrarModal(false);
                  generarPDF(selloSeleccionado);
                }}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
